import React, { useState } from "react";
import reactSelect from "react-select";

const VerticalCheckboxList = ({
	dataItems = [
		{ id: 1, text: "Option 1", checked: false },
		{ id: 2, text: "Option 2", checked: false },
		{ id: 3, text: "Option 3", checked: false },
	],
	handleOnChange,
	name = "checkbox",
}) => {
	const [items, setItems] = useState(dataItems);

	const handleCheckboxChange = (itemId) => {
		setItems((prevItems) =>
			prevItems.map((item) =>
				item.id === itemId ? { ...item, checked: !item.checked } : item
			)
		);
		handleOnChange({
			target: {
				name: name,
				value: items.map((item) =>
					item.id === itemId ? { ...item, checked: !item.checked } : item
				),
			},
		});
	};
	React.useEffect(() => {
		setItems(dataItems);
	}, [dataItems]);
	return (
		<div className="gap-4">
			{items.map((item) => (
				<label key={item.id} className="flex items-center space-x-2 p-2">
					<input
						type="checkbox"
						className="form-checkbox h-5 w-5 text-blue-600"
						checked={item.checked}
						onChange={() => handleCheckboxChange(item.id)}
					/>
					<span>{item.text}</span>
				</label>
			))}
		</div>
	);
};

export default VerticalCheckboxList;
